import React, { useState } from "react";
import clsx from "classnames";
/**
 * The switch component represents a boolean value that can be toggled on or off.
 */
export const Switch = ({ label = "", checked = false, onChange, ...rest }) => {
    const [focused, setFocused] = useState(false);
    const switchClasses = clsx("relative w-11 h-6 bg-gray-200 rounded-full peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-gray-800", {
        "border-solid border-4 border-red-300": focused,
    });
    return (<label className="inline-flex items-center cursor-pointer">
      <input type="checkbox" className="sr-only peer" checked={checked} aria-label={label} onChange={() => onChange?.(!checked)} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} {...rest}/>

      <div aria-checked={checked} className={switchClasses}></div>
      {label ? <span className="ms-3 text-lg text-black">{label}</span> : null}
    </label>);
};
